import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20Korean%20manhwa%20inspired%20illustration%20with%20warm%20coral%20and%20golden%20tones%20featuring%20flowing%20ink%20brush%20strokes%20and%20geometric%20patterns%20creating%20an%20energetic%20reading%20atmosphere%20abstract%20composition%20with%20soft%20gradients%20dark%20warm%20background&width=1800&height=800&seq=hero-bg-01&orientation=landscape"
        alt="韩漫屋 - 韩漫在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          韩漫屋
        </h1>
        <p className="text-base md:text-xl text-background-200 max-w-2xl mb-4 leading-relaxed">
          免费韩国漫画大全，无删减下拉式韩漫在线阅读
        </p>
        <p className="text-sm md:text-base text-background-300/80 max-w-xl mb-8">
          在韩漫屋体验舒适的韩漫在线阅读，所有无删减下拉式韩漫保证内容的原始风貌
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            立即阅读
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 border border-background-50/30 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">10,000+</p>
            <p className="text-xs text-background-300/70 mt-1">漫画资源</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">500万+</p>
            <p className="text-xs text-background-300/70 mt-1">月活读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">99.8%</p>
            <p className="text-xs text-background-300/70 mt-1">好评率</p>
          </div>
        </div>
      </div>
    </section>
  );
}